import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Resultado} from '../../interface/result.inteface';

@Component({
  selector: 'app-results-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './results-table.component.html',
  styleUrls: ['./results-table.component.scss']
})
export class ResultsTableComponent {
  @Input() title: string = '';
  @Input() data: Resultado[] = [];
  @Output() view = new EventEmitter<{ item: Resultado, guideId: string }>();

  onView(item: Resultado, guideId: string): void {
    this.view.emit({ item, guideId });
  }

  transformGuideId(guideId: string): string {
    if (!guideId) return 'Sin guía';
    const parts = guideId.split('-');
    if (parts.length === 2 && parts[0] === 'guia') {
      const roman = parts[1].toUpperCase();
      return `Guía ${roman}`;
    }
    return guideId;
  }
}
